'use strict';

(function ($) {
  function StickyDom(options) {
    this.options = $.extend({
      offset: 0,
      fixedPosition: 0
    }, options);

    this.init();
  }

  StickyDom.prototype = {
    init: function init() {
      if (this.options.holder) {
        this.findElements();
        this.startEvent();
      }
    },

    findElements() {
      this.holder = $(this.options.holder);
      this.parent = this.holder.parent();
      this.window = $(window);
    },

    startEvent() {
      this.parent.css('position', 'relative');
      this.window.on('scroll', this.changePosition.bind(this));
      this.changePosition();
    },

    changePosition() {
      const scroll = this.window.scrollTop();
      const parentHeight = this.parent.outerHeight() - this.holder.outerHeight();

      if (window.innerWidth > 991) {
        if (scroll >= this.options.offset && scroll <= parentHeight - (this.options.fixedPosition / 2)) {
          this.setFixed();
        } else if (scroll >= this.parent.outerHeight() - this.holder.outerHeight() - (this.options.fixedPosition / 2)) {
          this.setBot();
        } else {
          this.setDismiss();
        }
      } else {
        this.setDismiss();
      }
    },

    setFixed() {
      this.holder.css({
        position: 'fixed',
        top: this.options.fixedPosition,
        left: 'unset',
        right: 'unset',
        bottom: 'unset'
      }).trigger('setFixed');
    },

    setBot() {
      this.holder.css({
        position: 'absolute',
        left: 'unset',
        top: this.parent.outerHeight() - this.holder.outerHeight() - this.options.fixedPosition + 'px'
      });
    },

    setDismiss() {
      this.holder.attr('style', '');
    },
  };

  $.fn.stickyDom = function (opt) {
    return this.each(function () {
      $(this).data('StickyDom', new StickyDom($.extend({
        holder: this
      }, opt)));
    });
  };
})(jQuery);

$(window).on('load', function () {

  if (window.innerWidth > 991) {

    if ($('.posts.show').length) {
      let $header = $('header');
      let $bannerContainer = $('.banner');
      let fixedPoint = $header.height();
      let stickPoint = $bannerContainer.offset().top + $bannerContainer.outerHeight() - $header.height();

      $('.sticky-networks').stickyDom({
        offset: stickPoint,
        fixedPosition: fixedPoint
      });
    }
  }
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/sticky_social_networks.js